import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
  },
  container: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  title: {
    cursor: 'pointer',
    maxWidth: '360px',
    lineHeight: `${theme.spacing(3)}px`,
    fontSize: theme.spacing(2),
    color: (props: any) =>
      props.response === false ? theme.palette.grey[300] : '',
  },
  responseLabel: {
    fontSize: '14px',
  },
  formLabel: {
    marginRight: 0,
  },
}));

export default useStyles;
